import React, { useState } from 'react'
import "./CSS/Login.css"
import { Link } from 'react-router-dom'
import tringle from "../Assets/Triangle-Exclamation-Point.jpg"
import alert from "../Assets/2014825.png"
import { connect } from 'react-redux'
import logo from "../Assets/IMG-20230407-WA0001_transparent.png"
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { set_username, set_uid } from "../Action/Action"
import Store from '../Store/Store'

const SignUpPage = (props) => {

  const history = useHistory()

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];



  const [inp, SETINP] = useState("")
  const [parola, SetParola] = useState("")
  const [email, SetEmail] = useState("")

  const OnFormSubmit = async e => {
    e.preventDefault();
    console.log("ss*ğf");
    let password = document.querySelector("#Password")
    let username_ = document.querySelector("#Username")
    let email_ = document.querySelector("#Email")
    // CheckValidate([password, email_, username_])
    // //checkEmail(email_)
    // checkLength(password, 8, 20)
    // checkLength(username_, 6, 30)
    // CheckPassword(password)
    // checkPassword2(password)

    if (email === "info") {
      try {
        const req_ = await fetch(`https://app-rmmsapi.azurewebsites.net/api/person/CreateUser`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "accept": "application/json"
          },
          body: JSON.stringify({
            "username": inp,
            "password": parola,
            "email": email
          }) // Convert the body object to a JSON string
        })
        const response = await req_.json()
        console.log(response);
        if (response === true) {
          history.push("/")
        }
      } catch (err) {
        console.log(err, "aüaüaüaüaüaüüaaü");
      }
    } else {
      if (true) {
        try {
          const req_ = await fetch(`https://app-rmmsapi.azurewebsites.net/api/person/CreateUser`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              "accept": "application/json"
            },
            body: JSON.stringify({
              "username": inp,
              "password": parola,
              "email": email
            }) // Convert the body object to a JSON string
          })
          const response = await req_.json()
          console.log(response);
          if (response === true) {
            history.push("/")
          }
        } catch (err) {
          console.log(err);
        }
      }
    }


  }

  function checkPassword2(inp) {
    if (inp.value === "") {
      Error1(inp, "Password is required!")
    } else {
      if (inp.value.search(/[a-z]/i) < 0) {
        Error1(inp, "You must use at least one letter!")

      }
      else if (inp.value.search(/[0-9]/) < 0) {
        Error1(inp, "You must use at least one digit!")
      }
      else if (inp.value.search(/[!@#$%^&*()_+{}\[\]:;<>,.?~\\\-]/) < 0) {
        Error1(inp, "You must use at least one special character!");
      }
      else {
        console.log(313232);
        Success(inp)
      }
    }
  }
  const Error1 = (inp, msg) => {
    inp.className = "form-control is-invalid"
    const div = inp.nextElementSibling
    div.innerText = msg
    div.className = "inform_login_text invalid-feedback"
  }

  const Success = (inp) => {
    inp.className = "form-control is-valid"
    const div = inp.nextElementSibling
    div.innerText = ""
    div.className = ""
  }

  const checkEmail = (inp) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (inp.value === "") {
      Error1(inp, "Email is required!")
    } else {
      if (re.test(inp.value)) {
        Success(inp)
      } else {
        Error1(inp, "Invalid email address")
      }
    }

  }


  const CheckValidate = (inps) => {
    inps.forEach(inp => {
      if (inp.value === "") {
        Error1(inp, `Bu alan boş bırakılamaz!`)
      } else {
        Success(inp)
        return true
      }
    })
  }



  const checkLength = (inp, min, max) => {

    if (inp.value.length > max) {
      Error1(inp, `${inp.id} must contains no more than ${max} character!`)
    } else if (inp.value.length < min) {
      Error1(inp, `${inp.id} must contains at least ${min} character!`)
    } else {
      Success(inp)
      return true
    }
  }

  function CheckPassword(inp) {
    if (inp.value === "") {
      Error1(inp, `This field is required!`)
    } else {
      Success(inp)
    }
  }


  const change_inp = e => {
    SETINP(e.target.value)
  }
  const change_pwd = e => {
    SetParola(e.target.value)
  }
  const change_email = e => {
    SetEmail(e.target.value)
  }
  const [currentHour, SetcurrentHour] = useState(null)
  const [currentMinute, SetcurrentMinute] = useState(null)
  const [currentDay, SetcurrentDay] = useState(null)
  const [currentDay2, SetcurrentDay2] = useState(null)
  const [currentyear, Setcurrentyear] = useState(null)
  const [currentmonth, Setcurrentmonth] = useState(null)


  setInterval(() => {
    let now = new Date();
    SetcurrentHour(now.getHours())
    SetcurrentMinute(now.getMinutes())
    SetcurrentDay(now.getDay())
    Setcurrentmonth(now.getMonth())
    Setcurrentyear(now.getFullYear())
    SetcurrentDay2(daysOfWeek[now.getDay()])

  }, 1000)

  return (
    <>
      <header className='login_header'>
        <nav>
          <div className="nav-left-part">
            <img src="https://havadurumu15gunluk.xyz/img_t/1/3-h.gif" alt="" />
            <div>10 .c</div>

          </div>
          <div className="middlepart-nav">
            <div className='nav-time-part'>{currentHour}:{currentMinute < 10 ? `0${currentMinute}` : currentMinute}</div>
            <div>
              <div style={{ marginLeft: "5%" }} className="date-part-nav">
                {currentDay < 10 ? `0${currentDay}` : currentDay}/{currentmonth + 1 < 10 ? `0${currentmonth + 1}` : currentmonth + 1}/{currentyear}
              </div>
              <div className="day-part-nav">
                {currentDay2}
              </div>
            </div>
          </div>
          <div className="right-part-nav">
            <div><img className='trinagle-alert' src={tringle} /></div>
            <div><img style={{ width: "32px", height: "32px", marginLeft: "8px", marginRight: "8px", marginTop: "8px" }} src={alert} alt="" /></div>
            <div>
              <i className="fa-solid fa-user fa-sm"></i>
            </div>
          </div>
        </nav>
      </header>

      <section className="login-section">
        <div className="left-login">
          <img src={logo} alt="" />
        </div>
        <div className="right-login">
          <div className="card">
            <div className="card-header">
              Welcome to RMMS Platform
            </div>
            <div className="card-body">
              <form className='signup_form' onSubmit={OnFormSubmit}>
                <h6>Please sign up to use platform</h6>
                <div className="input-group">
                  <label htmlFor="username">Username</label>
                  <input value={inp} id='Username' onChange={change_inp} type="text" className='username0login_input' placeholder='username' />
                  <div className="inform_login_div"></div>
                  <label htmlFor="email">Email</label>
                  <input value={email} id='Email' onChange={change_email} type="text" className='login0email_input' placeholder='email' />
                  <div className='inform_login_div'></div>
                  <label htmlFor="password">Password</label>
                  <input value={parola} id='Password' onChange={change_pwd} type="password" className='password0login_input' placeholder='password' />
                  <div className='inform_login_div'></div>
                  <div className="btn_part_loginto">
                    <button >Sign Up <i className='fa fa-arrow-right'></i></button>
                  </div>
                  <span className="redirect_signup">
                    <p>Already have a account? <Link to={"/"}>Sign In</Link></p>
                  </span>
                </div>

              </form>
            </div>
          </div>

        </div>
      </section>
    </>
  )
}

const MapStateToProps = (state) => {
  return {
    user_id: state.auth_reducer.user_id
  }
}

export default connect(MapStateToProps)(SignUpPage)